var Handlebars = require("../js/handlebars");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"0":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "            "
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"full_name") : depth0), depth0))
    + "\n";
},"1":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "            "
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"username") : depth0), depth0))
    + "\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"flex mb-3 items-center rounded-lg transition-all\" style=\"padding: 0.625rem 0.625rem 0.625rem 0.5rem; transition-duration: 200ms;\" onmouseover=\"this.style.backgroundColor='rgba(241, 245, 249, 0.5)';\" onmouseout=\"this.style.backgroundColor='transparent';\">\n    <img class=\"rounded-full flex-shrink-0\" style=\"height: 40px; width: 40px;\" src=\""
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"avatar_url") : depth0), depth0))
    + "\" alt=\""
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"username") : depth0), depth0))
    + " avatar\">\n    <div class=\"flex-1 min-w-0 overflow-hidden\" style=\"margin-left: 0.5rem;\">\n        <a class=\"text-slate-900 font-semibold text-sm transition-colors block truncate\" style=\"transition-duration: 200ms;\" href=\"/"
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"username") : depth0), depth0))
    + "\" onmouseover=\"this.style.color='#0f172a';\" onmouseout=\"this.style.color='#0f172a';\">\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"full_name") : depth0),{"name":"if","hash":{},"fn":container.program(0, data, 0),"inverse":container.program(1, data, 0),"data":data,"loc":{"start":{"line":5,"column":9},"end":{"line":9,"column":15}}})) != null ? stack1 : "")
    + "        </a>\n    </div>\n"
    + ((stack1 = container.invokePartial(require("./follow_button.handlebars"),depth0,{"name":"follow_button","data":data,"indent":"    ","helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "")
    + "</div>\n";
},"usePartial":true,"useData":true});